import {GetRefundStates, GetRefundStatesParams, GetRefundStatesResponse} from 'domain/usecases';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteRefundGetStates implements GetRefundStates {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRefundStatesResponse>,
	) {}

	async get({signal}: GetRefundStatesParams): Promise<GetRefundStatesResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
